<mat-dialog-content data-test-id="dialog-message" tabindex="0" [innerHTML]="data.message"/>
@if (data.additionalContent) {
	<mat-list data-test-id="additional-content-list">
		@for (c of data.additionalContent; track c) {
			<mat-list-item tabindex="0"
	               data-test-id="additional-content-item">{{ c }}
	</mat-list-item>
		}
</mat-list>
}
<mat-dialog-actions>
	@for (label of data.label; track label; let idx = $index) {
		<button
	        mat-flat-button [class.mat-stroked-button]="!checkSaveButton(data.buttonType[idx])"
	        [class.mat-flat-button]="checkSaveButton(data.buttonType[idx])"
	        [class.dialogFocus]="data.selection == 0"
	        color="primary"
	        [mat-dialog-close]="data"
	        (mousedown)="select(idx, false)"
	        (keydown.enter)="select(idx, true)"
	        data-test-id="dialog-selection-option-button"
	        [disabled]="isDisabled(idx)"
	        class="focus-inwards-dark">{{ data.label[idx] }}
	</button>
	}
</mat-dialog-actions>
